"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var _get = require("lodash/get");
var TranslationProvider = /** @class */ (function () {
    function TranslationProvider(translationFactory, translations, providerInstance) {
        this.translationFactory = translationFactory;
        this.translations = translations;
        this.providerInstance = providerInstance;
        this.translations = this.formatTranslations(translations);
    }
    TranslationProvider.prototype.translate = function (opt, lang) {
        if (lang === void 0) { lang = 'en'; }
        if (lang && opt.path && opt.section) {
            return this.translateByPath(opt, lang);
        }
        var translation = this.translateByPriority(opt, lang);
        return translation || this.translateByPriority(opt, 'en');
    };
    TranslationProvider.prototype.translateByPath = function (opt, lang) {
        return _get(this.translations, opt.section + "." + lang + "." + opt.path);
    };
    TranslationProvider.prototype.translateByPriority = function (opt, lang) {
        for (var _i = 0, _a = this.providerInstance.PRIORITY; _i < _a.length; _i++) {
            var priority = _a[_i];
            var translated = this.translateByPath(__assign({}, opt, { section: priority }), lang);
            if (translated) {
                return translated;
            }
        }
        return '';
    };
    TranslationProvider.prototype.formatTranslations = function (payload) {
        var _this = this;
        if (!payload) {
            return {};
        }
        var sections = Object.keys(payload);
        return sections.reduce(function (obj, section) {
            var sectionName = _this.providerInstance.getProviderName(section);
            var langKeys = Object.keys(payload[section]);
            obj[sectionName] = langKeys.reduce(function (acc, key) {
                acc[key] = _this.translationFactory(key, payload[section][key]);
                return acc;
            }, {});
            return obj;
        }, {});
    };
    return TranslationProvider;
}());
exports.TranslationProvider = TranslationProvider;
//# sourceMappingURL=translation-provider.js.map